import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function AdminAnalytics({ client }) {
    const [data, setData] = useState(null);
    useEffect(() => {
        client.get("/admin/analytics").then(({ data }) => setData(data)).catch(() => toast.error("Failed to load analytics"));
    }, [client]);
    if (!data) return <Loader2 className="h-6 w-6 animate-spin text-forest" />;

    const totals = {};
    data.events.forEach((e) => { totals[e.event] = (totals[e.event] || 0) + e.count; });

    return (
        <div data-testid="admin-analytics" className="space-y-10">
            <div>
                <p className="mono-label text-moss mb-4">Inquiries by type</p>
                <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
                    {Object.entries(data.inquiries_by_type).map(([k, v]) => (
                        <div key={k} className="rounded-2xl bg-white/60 border border-hairline p-5">
                            <p className="font-serif text-4xl text-forest">{v}</p>
                            <p className="text-sm text-muted_text mt-1">{k}</p>
                        </div>
                    ))}
                </div>
            </div>
            <div>
                <p className="mono-label text-moss mb-4">Tracked events (visitors who accepted analytics cookies)</p>
                <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
                    {Object.entries(totals).map(([k, v]) => (
                        <div key={k} className="rounded-2xl bg-white/60 border border-hairline p-5" data-testid={`admin-event-${k}`}>
                            <p className="font-serif text-4xl text-forest">{v}</p>
                            <p className="text-sm text-muted_text mt-1">{k.replace(/_/g, " ")}</p>
                        </div>
                    ))}
                    {Object.keys(totals).length === 0 && <p className="text-muted_text">No events yet.</p>}
                </div>
            </div>
        </div>
    );
}
